module.exports = __webpack_public_path__ + "img/1141843315.9e9076f7.jpg";